var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50176 1.23657L8.2752 0.463135C8.62676 0.146729 9.1541 0.146729 9.47051 0.463135L16.326 7.28345C16.6424 7.63501 16.6424 8.16235 16.326 8.47876L9.47051 15.3342C9.1541 15.6506 8.62676 15.6506 8.2752 15.3342L7.50176 14.5608C7.18535 14.2092 7.18535 13.6819 7.50176 13.3303L11.7557 9.28735H1.66582C1.17363 9.28735 0.82207 8.93579 0.82207 8.4436V7.3186C0.82207 6.86157 1.17363 6.47485 1.66582 6.47485H11.7557L7.50176 2.46704C7.18535 2.11548 7.1502 1.58813 7.50176 1.23657Z",
    fill: "#0F101E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.b3311f6d486a54e2cecfc44abbfdb896.svg";
export { ForwardRef as ReactComponent };